export default {
  logged: false,
  usuario: {},
  auth: {
    token: null,
    refresh_token: null
  }
}
